var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0158 5.93673L7.65073 0.562522C7.40931 0.320696 7.09334 0.199937 6.777 0.200196C6.48284 0.201208 6.1683 0.321987 5.92596 0.563297L0.561652 5.93673C0.320494 6.17949 0.199946 6.49455 0.199951 6.78896C0.199956 7.10558 0.320504 7.42219 0.561662 7.66366L5.92674 13.0379C6.1683 13.3021 6.48284 13.4002 6.79995 13.4002C7.11602 13.4002 7.4321 13.2794 7.67316 13.0379L13.0382 7.66366C13.2793 7.42212 13.4 7.10558 13.4 6.78896C13.3767 6.49455 13.2788 6.17949 13.0158 5.93673ZM10.7832 6.7089L8.30815 8.87821C8.02997 9.12471 7.62417 8.90359 7.62417 8.56754V7.22541H5.95174L5.95174 8.46501C5.95174 8.91953 5.6037 9.29142 5.12674 9.29142C4.64979 9.29142 4.30174 8.91953 4.30174 8.46501V6.399C4.30174 5.94448 4.67299 5.5726 5.12674 5.5726H7.57854V4.22969C7.57854 3.87201 8.0011 3.68762 8.26252 3.91901L10.7375 6.08833C10.8734 6.16658 10.9017 6.28021 10.9017 6.399C10.9017 6.5178 10.8734 6.63143 10.7832 6.7089Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.aef3675df98be472dc9c1de95c6a0c29.svg";
export { ForwardRef as ReactComponent };